import request from 'services/axios'

export const getBoxes = async () => {
    const { data }: { data: IGetBoxes | undefined } = await request.get(
        '/api/v1/general/boxes/'
    )
    return data
}
